const cached_elements = new CacheElement();

let user_name;
let user_location;